import { Extension } from "@tiptap/core";

const DocumentSettings = Extension.create({
  name: "documentSettings",

  addOptions() {
    return {
      defaultPageFormat: "A4",
    };
  },

  addGlobalAttributes() {
    return [
      {
        types: ["doc"],
        attributes: {
          pageFormat: {
            default: this.options.defaultPageFormat,
            parseHTML: (element) =>
              element.getAttribute("data-page-format") ||
              this.options.defaultPageFormat,
            renderHTML: (attributes) => ({
              "data-page-format": attributes.pageFormat,
            }),
          },
        },
      },
    ];
  },

  addCommands() {
    return {
      setDocumentSetting:
        (key, value) =>
        ({ tr, dispatch }) => {
          if (dispatch) {
            tr.setDocAttribute(key, value);
          }
          return true;
        },
    };
  },
});

export default DocumentSettings;
